module.exports = __webpack_public_path__ + "img/physics--structure--and-reality-cover.a2b178b6.jpg";